export default __webpack_public_path__ + "static/Eddo_Verdoner_1-4084ea42aa15976df00a22eb92b5b0b9.jpg";